    <app-data-grid-comp
    [gridId]="gridId"
    [tableId]="db_tables.Reviews"
    [columns]="columns"
    [hideActionButtons]="true"
    [filterCategories]="filterCategories"
    
    [gridDataResult]="gridDataResult"
    [isLoading]="isLoading"
    [pageSize]="pageSize"
    [skip]="skip"
    [category]="translate.instant('MyReviews')"
    [rowSelectionSettings]="{
        canSelectRows: false,
        selectableMode: 'multiple',
        selectRowBy: 'id'
    }"
    clickableRows="true"
    [isLoading]="isLoading"
    [clearSelectedItems]="clearSelectedItems"
    searchable="true"
    [sortable]="{
        mode: 'multiple'
    }"
    [sortableColumns]="sortableColumns"
    [filterToggleDetails]="filterToggleDetails"
    (emitGridStateChangeEvent)="gridStateChange($event)"
    (emitOpenDialogEvent)="getReview($event)"
></app-data-grid-comp>
